import { createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../constants/Constants';
import { setDocumentData } from './newDocumentSlice';

const initialState = {
  isUploadDocumentConnected: false,
};

const documentConnectionSlice = createSlice({
  name: 'documentConnection',
  initialState,
  reducers: {
    connectDocumentSocket: (state, action) => {
      const socket = io(`${SOCKET_URL}`, { transports: ['websocket'] });
      const { userId } = action.payload;
      const { dispatch } = action.payload;
      try {
        socket.emit('documentUploadStatus', userId);
        socket.on('documentUCreated', (data) => {
          dispatch(setDocumentData(data));
        });
        return { ...state, isUploadDocumentConnected: true };
      } catch (error) {
        console.error(
          'Failed to connect to the document socket:',
          error.message,
        );
        return state;
      }
    },
    disconnectDocumentSocket: (state) => {
      if (state.socket) {
        state.socket.emit('disconnectRequest', 'disconnect socket');
      }
      return {
        ...state,
        isUploadDocumentConnected: false,
      };
    },
  },
});

export const { connectDocumentSocket, disconnectDocumentSocket } =
  documentConnectionSlice.actions;

export default documentConnectionSlice.reducer;
